import React from 'react'
import { PatternFormat } from 'react-number-format';

const PhoneNumberMask = ({ onChange, ...rest }) => {
    return (
        <PatternFormat
            {...rest}
            className="form-control"
            onValueChange={(values) => {
                const { formattedValue, value } = values;
                onChange(value)
            }}
        />
    );
};
export default PhoneNumberMask;